import { render, staticRenderFns } from "./travel_concierge.vue?vue&type=template&id=132473dc&"
import script from "./travel_concierge.vue?vue&type=script&lang=js&"
export * from "./travel_concierge.vue?vue&type=script&lang=js&"
import style0 from "./travel_concierge.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports